import Highway from '@dogstudio/highway'
import store from '@js/modules/store'

export default class PageRenderer extends Highway.Renderer {
    onEnter() {
        const page = this.wrap.lastElementChild

        // Launch global renderer
        store.globalRenderer.onEnter(page)
    }
    onEnterCompleted() {
        const page = this.wrap.lastElementChild

        // Animations
	    if(window.innerWidth >= 1024) {
            // Heading 1
            store.animizi.addHeading1(page.querySelector('.a-heading.-h1-2'), 0.75)
            // Top text
            if(page.querySelector('.o-top .a-text.-top'))
                store.animizi.addTopText(page.querySelector('.o-top .a-text.-top'), 1.15)
        }

        // Launch global renderer
        store.globalRenderer.onEnterCompleted(page)
    }
    onLeave() {
        // Launch global renderer
        store.globalRenderer.onLeave()
    }
    onLeaveCompleted() {
        // Launch global renderer
        store.globalRenderer.onLeaveCompleted()
    }
}
